<template>
  <nav
    class="px-lg-4 navbar navbar-expand-md align-items-center py-2 px-3 mb-3"
  >
    <router-link class="navbar-brand col" :to="{ name: 'home' }">
      <img src="@/assets/logo.png" alt="Logo" style="max-height: 36px; max-width: 150px" />
      <div v-if="userStore.connectedUser?.environment && userStore.connectedUser?.environment != 'Production'" class="badge ms-3 text-bg-warning">{{ userStore.connectedUser.environment }}</div>
    </router-link>
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Menu"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse justify-content-center" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <router-link :to="{ name: 'home' }" class="nav-link m-2 my-2 my-md-0 p-0">Accueil</router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'admin' }" class="nav-link m-2 my-2 my-md-0 p-0">Evénements</router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'admin-users' }" class="nav-link m-2 my-2 my-md-0 p-0">Utilisateurs</router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'admin-settings' }" class="nav-link m-2 my-2 my-md-0 p-0">Paramètres</router-link>
        </li>
        <li class="nav-item text-nowrap">
          <router-link :to="{ name: 'travel-board' }" class="nav-link m-2 my-2 my-md-0 p-0">Board</router-link>
        </li>
      </ul>
    </div>
    <div class="col d-none d-md-flex justify-content-end align-items-center gap-2">
      <router-link v-if="userStore.connectedUser" :to="{ name: 'profile' }" class="text-decoration-none text-body small">
        {{ userStore.connectedUser.firstName }} {{ userStore.connectedUser.lastName?.toUpperCase() }}
      </router-link>
      <a href="#" @click.prevent="handleLogout" title="Déconnexion">
        <span class="fa-stack">
          <i class="fa-regular fa-circle fa-stack-2x"></i>
          <i class="fa-solid fa-right-from-bracket fa-stack-1x"></i>
        </span>
      </a>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/userStore'

const userStore = useUserStore()
const router = useRouter()

const handleLogout = async () => {
  await userStore.logout()
  router.push('/')
}
</script>
